import React, { useEffect, useState } from "react";
import { MAP_URL } from "../../../../../Helpers/Chat/Constant";
import { REACT_APP_GOOGLE_GEOCODER_API_KEY, REACT_APP_GOOGLE_LOCATION_API_KEY } from "../../../../processENV";
import PropTypes from "prop-types";
import { getAddress } from "../../../../../Helpers/Utility";

const GoogleMapMarker = (props = {}) => {
    const [addressText, setAddressText] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    
    const { latitude = 0, longitude = 0 } = props;
    const geoCoderApiKey = REACT_APP_GOOGLE_GEOCODER_API_KEY;
    const apiKey = REACT_APP_GOOGLE_LOCATION_API_KEY;
    const file_url = `${MAP_URL}?center=${latitude},${longitude}&zoom=13&size=200x200&markers=color:red|${latitude},${longitude}&key=${apiKey}`;
    
    useEffect(() => {
        const fetchAddress = async () => {
            if (latitude === 0 && longitude === 0) {
                setAddressText("Location not available");
                setIsLoading(false);
                return;
            }
            
            try {
                setIsLoading(true);
                setError(null);
                const val = await getAddress(latitude, longitude, geoCoderApiKey);
                if (val && val.status === "OK" && val.results && val.results.length > 0) {
                    const formattedAddress = val.results[0].formatted_address;
                    setAddressText(formattedAddress);
                } else if (val && val.status === "ZERO_RESULTS") {
                    setAddressText("No address found for this location");
                } else if (val && val.error_message) {
                    setError(val.error_message);
                    setAddressText("Address not available");
                } else {
                    setAddressText("Address not available");
                }
            } catch (err) {
                console.error("Error fetching address:", err);
                setError("Unable to fetch address");
                setAddressText("Unable to fetch address");
            } finally {
                setIsLoading(false);
            }
        };
        
        fetchAddress();
    }, [latitude, longitude, geoCoderApiKey]);
    
    return ( 
        <div className="message-location">
            <a
                target="_blank"
                rel="noopener noreferrer"
                href={`https://www.google.com/maps/?q=${latitude},${longitude}`}
            >
                <img
                    src={file_url}
                    alt="location-map"
                />
            </a>
            {/* <div className="location_pin"> 
                <p>Pinned Location</p> 
                <span>
                    {isLoading ? "Loading address..." : addressText || "Address not available"}
                </span>
                {error && <span className="error-text" style={{color: 'red', fontSize: '0.85em'}}>{error}</span>}
            </div> */}
        </div> 
    );
};

export default GoogleMapMarker;

GoogleMapMarker.propTypes = {
    latitude: PropTypes.number,
    longitude: PropTypes.number,
};